export default __webpack_public_path__ + "static/mini-helix-bq-1-6f00223dfc49c5770c5d73f81157fd3f.jpg";